// extracted by mini-css-extract-plugin
module.exports = {"post":"style_post__lrKD1","menu":"style_menu__iuIVg"};